// GENERATED by scripts/generate-species-size.ts — do not edit.
// Source: PokeMiners Game Master pokemonSettings.pokedexHeightM /
// pokedexWeightKg, plus each Mega override's averageHeightM / averageWeightKg.
// 1134 rows. Key "<dex>" is the base body; "<dex>:<FORM>" a regional
// form (ALOLA / GALARIAN / HISUIAN / PALDEA) or a Mega (MEGA / MEGA_X / MEGA_Y).

/** [average height in metres, average weight in kilograms]. */
export const SPECIES_SIZE: Readonly<Record<string, readonly [number, number]>> = {
  "1": [0.7, 6.9],
  "2": [1, 13],
  "3": [2, 100],
  "3:MEGA": [2.4, 155.5],
  "4": [0.6, 8.5],
  "5": [1.1, 19],
  "6": [1.7, 90.5],
  "6:MEGA_X": [1.7, 110.5],
  "6:MEGA_Y": [1.7, 100.5],
  "7": [0.5, 9],
  "8": [1, 22.5],
  "9": [1.6, 85.5],
  "9:MEGA": [1.6, 101.1],
  "10": [0.3, 2.9],
  "11": [0.7, 9.9],
  "12": [1.1, 32],
  "13": [0.3, 3.2],
  "14": [0.6, 10],
  "15": [1, 29.5],
  "15:MEGA": [1.4, 40.5],
  "16": [0.3, 1.8],
  "17": [1.1, 30],
  "18": [1.5, 39.5],
  "18:MEGA": [2.2, 50.5],
  "19": [0.3, 3.5],
  "19:ALOLA": [0.3, 3.8],
  "20": [0.7, 18.5],
  "20:ALOLA": [0.7, 25.5],
  "21": [0.3, 2],
  "22": [1.2, 38],
  "23": [2, 6.9],
  "24": [3.5, 65],
  "25": [0.4, 6],
  "26": [0.8, 30],
  "26:ALOLA": [0.7, 21],
  "26:MEGA_X": [1.2, 38],
  "26:MEGA_Y": [1, 26],
  "27": [0.6, 12],
  "27:ALOLA": [0.7, 40],
  "28": [1, 29.5],
  "28:ALOLA": [1.2, 55],
  "29": [0.4, 7],
  "30": [0.8, 20],
  "31": [1.3, 60],
  "32": [0.5, 9],
  "33": [0.9, 19.5],
  "34": [1.4, 62],
  "35": [0.6, 7.5],
  "36": [1.3, 40],
  "37": [0.6, 9.9],
  "37:ALOLA": [0.6, 9.9],
  "38": [1.1, 19.9],
  "38:ALOLA": [1.1, 19.9],
  "39": [0.5, 5.5],
  "40": [1, 12],
  "41": [0.8, 7.5],
  "42": [1.6, 55],
  "43": [0.5, 5.4],
  "44": [0.8, 8.6],
  "45": [1.2, 18.6],
  "46": [0.3, 5.4],
  "47": [1, 29.5],
  "48": [1, 30],
  "49": [1.5, 12.5],
  "50": [0.2, 0.8],
  "50:ALOLA": [0.2, 1],
  "51": [0.7, 33.3],
  "51:ALOLA": [0.7, 66.6],
  "52": [0.4, 4.2],
  "52:ALOLA": [0.4, 4.2],
  "52:GALARIAN": [0.4, 7.5],
  "53": [1, 32],
  "53:ALOLA": [1.1, 33],
  "54": [0.8, 19.6],
  "55": [1.7, 76.6],
  "56": [0.5, 28],
  "57": [1, 32],
  "58": [0.7, 19],
  "58:HISUIAN": [0.8, 22.7],
  "59": [1.9, 155],
  "59:HISUIAN": [2, 168],
  "60": [0.6, 12.4],
  "61": [1, 20],
  "62": [1.3, 54],
  "63": [0.9, 19.5],
  "64": [1.3, 56.5],
  "65": [1.5, 48],
  "65:MEGA": [1.2, 48],
  "66": [0.8, 19.5],
  "67": [1.5, 70.5],
  "68": [1.6, 130],
  "69": [0.7, 4],
  "70": [1, 6.4],
  "71": [1.7, 15.5],
  "71:MEGA": [4.5, 125.5],
  "72": [0.9, 45.5],
  "73": [1.6, 55],
  "74": [0.4, 20],
  "74:ALOLA": [0.4, 20.3],
  "75": [1, 105],
  "75:ALOLA": [1, 110],
  "76": [1.4, 300],
  "76:ALOLA": [1.7, 316],
  "77": [1, 30],
  "77:GALARIAN": [0.8, 24],
  "78": [1.7, 95],
  "78:GALARIAN": [1.7, 80],
  "79": [1.2, 36],
  "79:GALARIAN": [1.2, 36],
  "80": [1.6, 78.5],
  "80:GALARIAN": [1.6, 70.5],
  "80:MEGA": [2, 120],
  "81": [0.3, 6],
  "82": [1, 60],
  "83": [0.8, 15],
  "83:GALARIAN": [0.8, 42],
  "84": [1.4, 39.2],
  "85": [1.8, 85.2],
  "86": [1.1, 90],
  "87": [1.7, 120],
  "88": [0.9, 30],
  "88:ALOLA": [0.7, 42],
  "89": [1.2, 30],
  "89:ALOLA": [1, 52],
  "90": [0.3, 4],
  "91": [1.5, 132.5],
  "92": [1.3, 0.1],
  "93": [1.6, 0.1],
  "94": [1.5, 40.5],
  "94:MEGA": [1.4, 40.5],
  "95": [8.8, 210],
  "96": [1, 32.4],
  "97": [1.6, 75.6],
  "98": [0.4, 6.5],
  "99": [1.3, 60],
  "100": [0.5, 10.4],
  "100:HISUIAN": [0.5, 13],
  "101": [1.2, 66.6],
  "101:HISUIAN": [1.2, 71],
  "102": [0.4, 2.5],
  "103": [2, 120],
  "103:ALOLA": [10.9, 415.6],
  "104": [0.4, 6.5],
  "105": [1, 45],
  "105:ALOLA": [1, 34],
  "106": [1.5, 49.8],
  "107": [1.4, 50.2],
  "108": [1.2, 65.5],
  "109": [0.6, 1],
  "110": [1.2, 9.5],
  "110:GALARIAN": [3, 16],
  "111": [1, 115],
  "112": [1.9, 120],
  "113": [1.1, 34.6],
  "114": [1, 35],
  "115": [2.2, 80],
  "115:MEGA": [2.2, 100],
  "116": [0.4, 8],
  "117": [1.2, 25],
  "118": [0.6, 15],
  "119": [1.3, 39],
  "120": [0.8, 34.5],
  "121": [1.1, 80],
  "121:MEGA": [2.3, 80],
  "122": [1.3, 54.5],
  "122:GALARIAN": [1.4, 56.8],
  "123": [1.5, 56],
  "124": [1.4, 40.6],
  "125": [1.1, 30],
  "126": [1.3, 44.5],
  "127": [1.5, 55],
  "127:MEGA": [1.7, 59],
  "128": [1.4, 88.4],
  "129": [0.9, 10],
  "130": [6.5, 235],
  "130:MEGA": [6.5, 305],
  "131": [2.5, 220],
  "132": [0.3, 4],
  "133": [0.3, 6.5],
  "134": [1, 29],
  "135": [0.8, 24.5],
  "136": [0.9, 25],
  "137": [0.8, 36.5],
  "138": [0.4, 7.5],
  "139": [1, 35],
  "140": [0.5, 11.5],
  "141": [1.3, 40.5],
  "142": [1.8, 59],
  "142:MEGA": [2.1, 79],
  "143": [2.1, 460],
  "144": [1.7, 55.4],
  "144:GALARIAN": [1.7, 50.9],
  "145": [1.6, 52.6],
  "145:GALARIAN": [1.6, 58.2],
  "146": [2, 60],
  "146:GALARIAN": [2, 66],
  "147": [1.8, 3.3],
  "148": [4, 16.5],
  "149": [2.2, 210],
  "149:MEGA": [2.2, 290],
  "150": [2, 122],
  "150:MEGA_X": [2.3, 127],
  "150:MEGA_Y": [1.5, 33],
  "151": [0.4, 4],
  "152": [0.89, 6.4],
  "153": [1.19, 15.8],
  "154": [1.8, 100.5],
  "155": [0.51, 7.9],
  "156": [0.89, 19],
  "157": [1.7, 79.5],
  "157:HISUIAN": [1.6, 69.8],
  "158": [0.61, 9.5],
  "159": [1.09, 25],
  "160": [2.31, 88.8],
  "161": [0.79, 6],
  "162": [1.8, 32.5],
  "163": [0.71, 21.2],
  "164": [1.6, 40.8],
  "165": [0.99, 10.8],
  "166": [1.4, 35.6],
  "167": [0.51, 8.5],
  "168": [1.09, 33.5],
  "169": [1.8, 75],
  "170": [0.51, 12],
  "171": [1.19, 22.5],
  "172": [0.3, 2],
  "173": [0.3, 3],
  "174": [0.3, 1],
  "175": [0.3, 1.5],
  "176": [0.61, 3.2],
  "177": [0.2, 2],
  "178": [1.5, 15],
  "179": [0.61, 7.8],
  "180": [0.79, 13.3],
  "181": [1.4, 61.5],
  "181:MEGA": [1.4, 61.5],
  "182": [0.41, 5.8],
  "183": [0.41, 8.5],
  "184": [0.79, 28.5],
  "185": [1.19, 38],
  "186": [1.09, 33.9],
  "187": [0.41, 0.5],
  "188": [0.61, 1],
  "189": [0.79, 3],
  "190": [0.79, 11.5],
  "191": [0.3, 1.8],
  "192": [0.79, 8.5],
  "193": [1.19, 38],
  "194": [0.41, 8.5],
  "194:PALDEA": [0.41, 11],
  "195": [1.4, 75],
  "196": [0.89, 26.5],
  "197": [0.99, 27],
  "198": [0.51, 2.1],
  "199": [2.01, 79.5],
  "199:GALARIAN": [1.8, 79.5],
  "200": [0.71, 1],
  "201": [0.51, 5],
  "202": [1.3, 28.5],
  "203": [1.5, 41.5],
  "204": [0.61, 7.2],
  "205": [1.19, 125.8],
  "206": [1.5, 14],
  "207": [1.09, 64.8],
  "208": [9.19, 400],
  "208:MEGA": [10.5, 740],
  "209": [0.61, 7.8],
  "210": [1.4, 48.7],
  "211": [0.51, 3.9],
  "211:HISUIAN": [0.51, 3.9],
  "212": [2.01, 125],
  "212:MEGA": [2, 125],
  "213": [0.61, 20.5],
  "214": [1.5, 54],
  "214:MEGA": [1.7, 62.5],
  "215": [0.89, 28],
  "215:HISUIAN": [0.9, 27],
  "216": [0.61, 8.8],
  "217": [1.8, 125.8],
  "218": [0.71, 35],
  "219": [0.79, 55],
  "220": [0.41, 6.5],
  "221": [1.09, 55.8],
  "222": [0.61, 5],
  "222:GALARIAN": [0.61, 0.5],
  "223": [0.61, 12],
  "224": [0.89, 28.5],
  "225": [0.89, 16],
  "226": [2.11, 220],
  "227": [1.7, 50.5],
  "227:MEGA": [1.7, 40.4],
  "228": [0.61, 10.8],
  "229": [1.4, 35],
  "229:MEGA": [1.9, 49.5],
  "230": [1.8, 152],
  "231": [0.51, 33.5],
  "232": [1.09, 120],
  "233": [0.61, 32.5],
  "234": [1.4, 71.2],
  "235": [1.19, 58],
  "236": [0.71, 21],
  "237": [1.4, 48],
  "238": [0.41, 6],
  "239": [0.61, 23.5],
  "240": [0.71, 21.4],
  "241": [1.19, 75.5],
  "242": [1.5, 46.8],
  "243": [1.91, 178],
  "244": [2.11, 198],
  "245": [2.01, 187],
  "246": [0.61, 72],
  "247": [1.19, 152],
  "248": [2.01, 202],
  "248:MEGA": [2.5, 255],
  "249": [5.21, 216],
  "250": [3.81, 199],
  "251": [0.61, 5],
  "252": [0.51, 5],
  "253": [0.89, 21.6],
  "254": [1.7, 52.2],
  "254:MEGA": [1.9, 55.2],
  "255": [0.41, 2.5],
  "256": [0.89, 19.5],
  "257": [1.91, 52],
  "257:MEGA": [1.9, 52],
  "258": [0.41, 7.6],
  "259": [0.71, 28],
  "260": [1.5, 81.9],
  "260:MEGA": [1.9, 102],
  "261": [0.51, 13.6],
  "262": [0.99, 37],
  "263": [0.4, 17.5],
  "263:GALARIAN": [0.4, 17.5],
  "264": [0.5, 32.5],
  "264:GALARIAN": [0.5, 32.5],
  "265": [0.3, 3.6],
  "266": [0.61, 10],
  "267": [0.99, 28.4],
  "268": [0.71, 11.5],
  "269": [1.19, 31.6],
  "270": [0.51, 2.6],
  "271": [1.19, 32.5],
  "272": [1.5, 55],
  "273": [0.51, 4],
  "274": [0.99, 28],
  "275": [1.3, 59.6],
  "276": [0.3, 2.3],
  "277": [0.71, 19.8],
  "278": [0.61, 9.5],
  "279": [1.19, 28],
  "280": [0.41, 6.6],
  "281": [0.79, 20.2],
  "282": [1.6, 48.4],
  "282:MEGA": [1.6, 48.4],
  "283": [0.51, 1.7],
  "284": [0.79, 3.6],
  "285": [0.41, 4.5],
  "286": [1.19, 39.2],
  "287": [0.79, 24],
  "288": [1.4, 46.5],
  "289": [2.01, 130.5],
  "290": [0.51, 5.5],
  "291": [0.79, 12],
  "292": [0.79, 1.2],
  "293": [0.61, 16.3],
  "294": [0.99, 40.5],
  "295": [1.5, 84],
  "296": [0.99, 86.4],
  "297": [2.31, 253.8],
  "298": [0.2, 2],
  "299": [0.99, 97],
  "300": [0.61, 11],
  "301": [1.09, 32.6],
  "302": [0.51, 11],
  "302:MEGA": [0.5, 161],
  "303": [0.61, 11.5],
  "303:MEGA": [1, 23.5],
  "304": [0.41, 60],
  "305": [0.89, 120],
  "306": [2.11, 360],
  "306:MEGA": [2.2, 395],
  "307": [0.61, 11.2],
  "308": [1.3, 31.5],
  "308:MEGA": [1.3, 31.5],
  "309": [0.61, 15.2],
  "310": [1.5, 40.2],
  "310:MEGA": [1.8, 44],
  "311": [0.41, 4.2],
  "312": [0.41, 4.2],
  "313": [0.71, 17.7],
  "314": [0.61, 17.7],
  "315": [0.3, 2],
  "316": [0.41, 10.3],
  "317": [1.7, 80],
  "318": [0.79, 20.8],
  "319": [1.8, 88.8],
  "319:MEGA": [1.8, 88.8],
  "320": [2.01, 130],
  "321": [14.5, 398],
  "322": [0.71, 24],
  "323": [1.91, 220],
  "323:MEGA": [2.5, 320.5],
  "324": [0.51, 80.4],
  "325": [0.71, 30.6],
  "326": [0.89, 71.5],
  "327": [1.09, 5],
  "328": [0.71, 15],
  "329": [1.09, 15.3],
  "330": [2.01, 82],
  "331": [0.41, 51.3],
  "332": [1.3, 77.4],
  "333": [0.41, 1.2],
  "334": [1.09, 20.6],
  "334:MEGA": [1.5, 20.6],
  "335": [1.3, 40.3],
  "336": [2.69, 52.5],
  "337": [0.99, 168],
  "338": [1.19, 154],
  "339": [0.41, 1.9],
  "340": [0.89, 23.6],
  "341": [0.61, 11.5],
  "342": [1.09, 32.8],
  "343": [0.51, 21.5],
  "344": [1.5, 108],
  "345": [0.99, 23.8],
  "346": [1.5, 60.4],
  "347": [0.71, 12.5],
  "348": [1.5, 68.2],
  "349": [0.61, 7.4],
  "350": [6.2, 162],
  "351": [0.3, 0.8],
  "352": [0.99, 22],
  "353": [0.61, 2.3],
  "354": [1.09, 12.5],
  "354:MEGA": [1.2, 13],
  "355": [0.79, 15],
  "356": [1.6, 30.6],
  "357": [2.01, 100],
  "358": [0.61, 1],
  "359": [1.2, 47],
  "359:MEGA": [1.2, 49],
  "360": [0.61, 14],
  "361": [0.71, 16.8],
  "362": [1.5, 256.5],
  "362:MEGA": [2.1, 350.2],
  "363": [0.79, 39.5],
  "364": [1.09, 87.6],
  "365": [1.4, 150.6],
  "366": [0.41, 52.5],
  "367": [1.7, 27],
  "368": [1.8, 22.6],
  "369": [0.99, 23.4],
  "370": [0.61, 8.7],
  "371": [0.61, 42.1],
  "372": [1.09, 110.5],
  "373": [1.5, 102.6],
  "373:MEGA": [1.8, 112.6],
  "374": [0.61, 95.2],
  "375": [1.19, 202.5],
  "376": [1.6, 550],
  "376:MEGA": [2.5, 942.9],
  "377": [1.7, 230],
  "378": [1.8, 175],
  "379": [1.91, 205],
  "380": [1.4, 40],
  "380:MEGA": [1.8, 52],
  "381": [2.01, 60],
  "381:MEGA": [2.3, 70],
  "382": [4.5, 352],
  "383": [3.51, 950],
  "384": [7.01, 206.5],
  "384:MEGA": [10.8, 392],
  "385": [0.3, 1.1],
  "386": [1.7, 60.8],
  "387": [0.4, 10.2],
  "388": [1.1, 97],
  "389": [2.2, 310],
  "390": [0.5, 6.2],
  "391": [0.9, 22],
  "392": [1.2, 55],
  "393": [0.4, 5.2],
  "394": [0.8, 23],
  "395": [1.7, 84.5],
  "396": [0.3, 2],
  "397": [0.6, 15.5],
  "398": [1.2, 24.9],
  "399": [0.5, 20],
  "400": [1, 31.5],
  "401": [0.3, 2.2],
  "402": [1, 25.5],
  "403": [0.5, 9.5],
  "404": [0.9, 30.5],
  "405": [1.4, 42],
  "406": [0.2, 1.2],
  "407": [0.9, 14.5],
  "408": [0.9, 31.5],
  "409": [1.6, 102.5],
  "410": [0.5, 57],
  "411": [1.3, 149.5],
  "412": [0.2, 3.4],
  "413": [0.5, 6.5],
  "414": [0.9, 23.3],
  "415": [0.3, 5.5],
  "416": [1.2, 38.5],
  "417": [0.4, 3.9],
  "418": [0.7, 29.5],
  "419": [1.1, 33.5],
  "420": [0.4, 3.3],
  "421": [0.5, 9.3],
  "422": [0.3, 6.3],
  "423": [0.9, 29.9],
  "424": [1.2, 20.3],
  "425": [0.4, 1.2],
  "426": [1.2, 15],
  "427": [0.4, 5.5],
  "428": [1.2, 33.3],
  "428:MEGA": [1.3, 28.3],
  "429": [0.9, 4.4],
  "430": [0.9, 27.3],
  "431": [0.5, 3.9],
  "432": [1, 43.8],
  "433": [0.2, 0.6],
  "434": [0.4, 19.2],
  "435": [1, 38],
  "436": [0.5, 60.5],
  "437": [1.3, 187],
  "438": [0.5, 15],
  "439": [0.6, 13],
  "440": [0.6, 24.4],
  "441": [0.5, 1.9],
  "442": [1, 108],
  "443": [0.7, 20.5],
  "444": [1.4, 56],
  "445": [1.9, 95],
  "445:MEGA": [1.9, 95],
  "446": [0.6, 105],
  "447": [0.7, 20.2],
  "448": [1.2, 54],
  "448:MEGA": [1.3, 57.5],
  "449": [0.8, 49.5],
  "450": [2, 300],
  "451": [0.8, 12],
  "452": [1.3, 61.5],
  "453": [0.7, 23],
  "454": [1.3, 44.4],
  "455": [1.4, 27],
  "456": [0.4, 7],
  "457": [1.2, 24],
  "458": [1, 65],
  "459": [1, 50.5],
  "460": [2.2, 135.5],
  "460:MEGA": [2.7, 185],
  "461": [1.1, 34],
  "462": [1.2, 180],
  "463": [1.7, 140],
  "464": [2.4, 282.8],
  "465": [2, 128.6],
  "466": [1.8, 138.6],
  "467": [1.6, 68],
  "468": [1.5, 38],
  "469": [1.9, 51.5],
  "470": [1, 25.5],
  "471": [0.8, 25.9],
  "472": [2, 42.5],
  "473": [2.5, 291],
  "474": [0.9, 34],
  "475": [1.6, 52],
  "475:MEGA": [1.6, 56.4],
  "476": [1.4, 340],
  "477": [2.2, 106.6],
  "478": [1.3, 26.6],
  "479": [0.3, 0.3],
  "480": [0.3, 0.3],
  "481": [0.3, 0.3],
  "482": [0.3, 0.3],
  "483": [5.4, 683],
  "484": [4.2, 336],
  "485": [1.7, 430],
  "486": [3.7, 420],
  "487": [4.5, 750],
  "488": [1.5, 85.6],
  "489": [0.4, 3.1],
  "490": [0.3, 1.4],
  "491": [1.5, 50.5],
  "492": [0.2, 2.1],
  "493": [3.2, 320],
  "494": [0.4, 4],
  "495": [0.6, 8.1],
  "496": [0.8, 16],
  "497": [3.3, 63],
  "498": [0.5, 9.9],
  "499": [1, 55.5],
  "500": [1.6, 150],
  "501": [0.5, 5.9],
  "502": [0.8, 24.5],
  "503": [1.5, 94.6],
  "503:HISUIAN": [1.5, 58.2],
  "504": [0.5, 11.6],
  "505": [1.1, 27],
  "506": [0.4, 4.1],
  "507": [0.9, 14.7],
  "508": [1.2, 61],
  "509": [0.4, 10.1],
  "510": [1.1, 37.5],
  "511": [0.6, 10.5],
  "512": [1.1, 30.5],
  "513": [0.6, 11],
  "514": [1, 28],
  "515": [0.6, 13.5],
  "516": [1, 29],
  "517": [0.6, 23.3],
  "518": [1.1, 60.5],
  "519": [0.3, 2.1],
  "520": [0.6, 15],
  "521": [1.2, 29],
  "522": [0.8, 29.8],
  "523": [1.6, 79.5],
  "524": [0.4, 18],
  "525": [0.9, 102],
  "526": [1.7, 260],
  "527": [0.4, 2.1],
  "528": [0.9, 10.5],
  "529": [0.3, 8.5],
  "530": [0.7, 40.4],
  "531": [1.1, 31],
  "531:MEGA": [1.5, 32],
  "532": [0.6, 12.5],
  "533": [1.2, 40],
  "534": [1.4, 87],
  "535": [0.5, 4.5],
  "536": [0.8, 17],
  "537": [1.5, 62],
  "538": [1.3, 55.5],
  "539": [1.4, 51],
  "540": [0.3, 2.5],
  "541": [0.5, 7.3],
  "542": [1.2, 20.5],
  "543": [0.4, 5.3],
  "544": [1.2, 58.5],
  "545": [2.5, 200.5],
  "546": [0.3, 0.6],
  "547": [0.7, 6.6],
  "548": [0.5, 6.6],
  "549": [1.1, 16.3],
  "549:HISUIAN": [1.2, 19.2],
  "550": [1, 18],
  "551": [0.7, 15.2],
  "552": [1, 33.4],
  "553": [1.5, 96.3],
  "554": [0.6, 37.5],
  "554:GALARIAN": [0.7, 40],
  "555": [1.3, 92.9],
  "556": [1, 28],
  "557": [0.3, 14.5],
  "558": [1.4, 200],
  "559": [0.6, 11.8],
  "560": [1.1, 30],
  "561": [1.4, 14],
  "562": [0.5, 1.5],
  "562:GALARIAN": [0.5, 1.5],
  "563": [1.7, 76.5],
  "564": [0.7, 16.5],
  "565": [1.2, 81],
  "566": [0.5, 9.5],
  "567": [1.4, 32],
  "568": [0.6, 31],
  "569": [1.9, 107.3],
  "570": [0.7, 12.5],
  "570:HISUIAN": [0.7, 12.5],
  "571": [1.6, 81.1],
  "571:HISUIAN": [1.6, 81.1],
  "572": [0.4, 5.8],
  "573": [0.5, 7.5],
  "574": [0.4, 5.8],
  "575": [0.7, 18],
  "576": [1.5, 44],
  "577": [0.3, 1],
  "578": [0.6, 8],
  "579": [1, 20.1],
  "580": [0.5, 5.5],
  "581": [1.3, 24.2],
  "582": [0.4, 5.7],
  "583": [1.1, 41],
  "584": [1.3, 57.5],
  "585": [0.6, 19.5],
  "586": [1.9, 92.5],
  "587": [0.4, 5],
  "588": [0.5, 5.9],
  "589": [1, 33],
  "590": [0.2, 1],
  "591": [0.6, 10.5],
  "592": [1.2, 33],
  "593": [2.2, 135],
  "594": [1.2, 31.6],
  "595": [0.1, 0.6],
  "596": [0.8, 14.3],
  "597": [0.6, 18.8],
  "598": [1, 110],
  "599": [0.3, 21],
  "600": [0.6, 51],
  "601": [0.6, 81],
  "602": [0.2, 0.3],
  "603": [1.2, 22],
  "604": [2.1, 80.5],
  "605": [0.5, 9],
  "606": [1, 34.5],
  "607": [0.3, 3.1],
  "608": [0.6, 13],
  "609": [1, 34.3],
  "610": [0.6, 18],
  "611": [1, 36],
  "612": [1.8, 105.5],
  "613": [0.5, 8.5],
  "614": [2.6, 260],
  "615": [1.1, 148],
  "616": [0.4, 7.7],
  "617": [0.8, 25.3],
  "618": [0.7, 11],
  "618:GALARIAN": [0.7, 20.5],
  "619": [0.9, 20],
  "620": [1.4, 35.5],
  "621": [1.6, 139],
  "622": [1, 92],
  "623": [2.8, 330],
  "624": [0.5, 10.2],
  "625": [1.6, 70],
  "626": [1.6, 94.6],
  "627": [0.5, 10.5],
  "628": [1.5, 41],
  "628:HISUIAN": [1.7, 43.4],
  "629": [0.5, 9],
  "630": [1.2, 39.5],
  "631": [1.4, 58],
  "632": [0.3, 33],
  "633": [0.8, 17.3],
  "634": [1.4, 50],
  "635": [1.8, 160],
  "636": [1.1, 28.8],
  "637": [1.6, 46],
  "638": [2.1, 250],
  "639": [1.9, 260],
  "640": [2, 200],
  "641": [1.5, 63],
  "642": [1.5, 61],
  "643": [3.2, 330],
  "644": [2.9, 345],
  "645": [1.5, 68],
  "646": [3, 325],
  "647": [1.4, 48.5],
  "648": [0.6, 6.5],
  "649": [1.5, 82.5],
  "650": [0.4, 9],
  "651": [0.7, 29],
  "652": [1.6, 90],
  "652:MEGA": [1.6, 90],
  "653": [0.4, 9.4],
  "654": [1, 14.5],
  "655": [1.5, 39],
  "655:MEGA": [1.5, 39],
  "656": [0.3, 7],
  "657": [0.6, 10.9],
  "658": [1.5, 40],
  "658:MEGA": [1.5, 40],
  "659": [0.4, 5],
  "660": [1, 42.4],
  "661": [0.3, 1.7],
  "662": [0.7, 16],
  "663": [1.2, 24.5],
  "664": [0.3, 2.5],
  "665": [0.3, 8.4],
  "666": [1.2, 17],
  "667": [0.6, 13.5],
  "668": [1.5, 81.5],
  "669": [0.1, 0.1],
  "670": [0.2, 0.9],
  "671": [1.1, 10],
  "672": [0.9, 31],
  "673": [1.7, 91],
  "674": [0.6, 8],
  "675": [2.1, 136],
  "676": [1.2, 28],
  "677": [0.3, 3.5],
  "678": [0.6, 8.5],
  "679": [0.8, 2],
  "680": [0.8, 4.5],
  "681": [1.7, 53],
  "682": [0.2, 0.5],
  "683": [0.8, 15.5],
  "684": [0.4, 3.5],
  "685": [0.8, 5],
  "686": [0.4, 3.5],
  "687": [1.5, 47],
  "687:MEGA": [2.9, 69.8],
  "688": [0.5, 31],
  "689": [1.3, 96],
  "690": [0.5, 7.3],
  "691": [1.8, 81.5],
  "692": [0.5, 8.3],
  "693": [1.3, 35.3],
  "694": [0.5, 6],
  "695": [1, 21],
  "696": [0.8, 26],
  "697": [2.5, 270],
  "698": [1.3, 25.2],
  "699": [2.7, 225],
  "700": [1, 23.5],
  "701": [0.8, 21.5],
  "702": [0.2, 2.2],
  "703": [0.3, 5.7],
  "704": [0.3, 2.8],
  "705": [0.8, 17.5],
  "706": [2, 150.5],
  "707": [0.2, 3],
  "708": [0.4, 7],
  "709": [1.5, 71],
  "710": [0.3, 3.5],
  "711": [0.7, 9.5],
  "712": [1, 99.5],
  "713": [2, 505],
  "713:HISUIAN": [1.4, 262.4],
  "714": [0.5, 8],
  "715": [1.5, 85],
  "716": [3, 215],
  "717": [5.8, 203],
  "718": [5, 305],
  "719": [0.7, 8.8],
  "719:MEGA": [1.1, 27.8],
  "720": [0.5, 9],
  "721": [1.7, 195],
  "722": [0.3, 1.5],
  "723": [0.7, 16],
  "724": [1.6, 36.6],
  "724:HISUIAN": [1.6, 37],
  "725": [0.4, 4.3],
  "726": [0.7, 25],
  "727": [1.8, 83],
  "728": [0.4, 7.5],
  "729": [0.6, 17.5],
  "730": [1.8, 44],
  "731": [0.3, 1.2],
  "732": [0.6, 14.8],
  "733": [1.1, 26],
  "734": [0.4, 6],
  "735": [0.7, 14.2],
  "736": [0.4, 4.4],
  "737": [0.5, 10.5],
  "738": [1.5, 45],
  "739": [0.6, 7],
  "740": [1.7, 180],
  "741": [0.6, 3.4],
  "742": [0.1, 0.2],
  "743": [0.2, 0.5],
  "744": [0.5, 9.2],
  "745": [0.8, 25],
  "746": [0.2, 0.3],
  "747": [0.4, 8],
  "748": [0.7, 14.5],
  "749": [1, 110],
  "750": [2.5, 920],
  "751": [0.3, 4],
  "752": [1.8, 82],
  "753": [0.3, 1.5],
  "754": [0.9, 18.5],
  "755": [0.2, 1.5],
  "756": [1, 11.5],
  "757": [0.6, 4.8],
  "758": [1.2, 22.2],
  "759": [0.5, 6.8],
  "760": [2.1, 135],
  "761": [0.3, 3.2],
  "762": [0.7, 8.2],
  "763": [1.2, 21.4],
  "764": [0.1, 0.3],
  "765": [1.5, 76],
  "766": [2, 82.8],
  "767": [0.5, 12],
  "768": [2, 108],
  "769": [0.5, 70],
  "770": [1.3, 250],
  "771": [0.3, 1.2],
  "772": [1.9, 120.5],
  "773": [2.3, 100.5],
  "774": [0.3, 40],
  "775": [0.4, 19.9],
  "776": [2, 212],
  "777": [0.3, 3.3],
  "778": [0.2, 0.7],
  "779": [0.9, 19],
  "780": [3, 185],
  "781": [3.9, 210],
  "782": [0.6, 29.7],
  "783": [1.2, 47],
  "784": [1.6, 78.2],
  "785": [1.8, 20.5],
  "786": [1.2, 18.6],
  "787": [1.9, 45.5],
  "788": [1.3, 21.2],
  "789": [0.2, 0.1],
  "790": [0.1, 999.9],
  "791": [3.4, 230],
  "792": [4, 120],
  "793": [1.2, 55.5],
  "794": [2.4, 333.6],
  "795": [1.8, 25],
  "796": [3.8, 100],
  "797": [9.2, 999.9],
  "798": [0.3, 0.1],
  "799": [5.5, 888],
  "800": [2.4, 230],
  "801": [1, 80.5],
  "802": [0.7, 22.2],
  "803": [0.6, 1.8],
  "804": [3.6, 150],
  "805": [5.5, 820],
  "806": [1.8, 13],
  "807": [1.5, 44.5],
  "808": [0.2, 8],
  "809": [2.5, 800],
  "810": [0.3, 5],
  "811": [0.7, 14],
  "812": [2.1, 90],
  "813": [0.3, 4.5],
  "814": [0.6, 9],
  "815": [1.4, 33],
  "816": [0.3, 4],
  "817": [0.7, 11.5],
  "818": [1.9, 45.2],
  "819": [0.3, 2.5],
  "820": [0.6, 6],
  "821": [0.2, 1.8],
  "822": [0.8, 16],
  "823": [2.2, 75],
  "824": [0.4, 8],
  "825": [0.4, 19.5],
  "826": [0.4, 40.8],
  "827": [0.6, 8.9],
  "828": [1.2, 19.9],
  "829": [0.4, 2.2],
  "830": [0.5, 2.5],
  "831": [0.6, 6],
  "832": [1.3, 43],
  "833": [0.3, 8.5],
  "834": [1, 115.5],
  "835": [0.3, 13.5],
  "836": [1, 34],
  "837": [0.3, 12],
  "838": [1.1, 78],
  "839": [2.8, 310.5],
  "840": [0.2, 0.5],
  "841": [0.3, 1],
  "842": [0.4, 13],
  "843": [2.2, 7.6],
  "844": [3.8, 65.5],
  "845": [0.8, 18],
  "846": [0.5, 1],
  "847": [1.3, 30],
  "848": [0.4, 11],
  "849": [1.6, 40],
  "850": [0.7, 1],
  "851": [3, 120],
  "852": [0.6, 4],
  "853": [1.6, 39],
  "854": [0.1, 0.2],
  "855": [0.2, 0.4],
  "856": [0.4, 3.4],
  "857": [0.6, 4.8],
  "858": [2.1, 5.1],
  "859": [0.4, 5.5],
  "860": [0.8, 12.5],
  "861": [1.5, 61],
  "862": [1.6, 46],
  "863": [0.8, 28],
  "864": [1, 0.4],
  "865": [0.8, 117],
  "866": [1.5, 58.2],
  "867": [1.6, 66.6],
  "868": [0.2, 0.3],
  "869": [0.3, 0.5],
  "870": [3, 62],
  "870:MEGA": [1.6, 99],
  "871": [0.3, 1],
  "872": [0.3, 3.8],
  "873": [1.3, 42],
  "874": [2.5, 520],
  "875": [1.4, 89],
  "876": [0.9, 28],
  "877": [0.3, 3],
  "878": [1.2, 100],
  "879": [1.2, 100],
  "880": [1.8, 190],
  "881": [2.3, 150],
  "882": [2.3, 215],
  "883": [2, 175],
  "884": [1.8, 40],
  "885": [0.5, 2],
  "886": [1.4, 11],
  "887": [3, 50],
  "888": [2.8, 110],
  "889": [2.9, 210],
  "890": [20, 950],
  "891": [0.6, 12],
  "892": [1.9, 105],
  "893": [1.8, 70],
  "894": [1.2, 145],
  "895": [2.1, 200],
  "896": [2.2, 800],
  "897": [2, 44.5],
  "898": [1.1, 7.7],
  "899": [1.8, 95.1],
  "900": [1.8, 89],
  "901": [2.4, 290],
  "903": [1.3, 43],
  "904": [2.5, 60.5],
  "905": [1.6, 48],
  "906": [0.4, 4.1],
  "907": [0.9, 12.2],
  "908": [1.5, 31.2],
  "909": [0.4, 9.8],
  "910": [1, 30.7],
  "911": [1.6, 326.5],
  "912": [0.5, 6.1],
  "913": [1.2, 21.5],
  "914": [1.8, 61.9],
  "915": [0.5, 10.2],
  "916": [1, 120],
  "917": [0.3, 4],
  "918": [1, 16.5],
  "919": [0.2, 1],
  "920": [1, 17.5],
  "921": [0.3, 2.5],
  "922": [0.4, 6.5],
  "923": [0.9, 41],
  "924": [0.3, 1.8],
  "925": [0.3, 2.3],
  "926": [0.3, 10.9],
  "927": [0.5, 14.9],
  "928": [0.3, 6.5],
  "929": [0.6, 11.9],
  "930": [1.4, 48.2],
  "931": [0.6, 2.4],
  "932": [0.4, 16],
  "933": [0.6, 105],
  "934": [2.3, 240],
  "935": [0.6, 10.5],
  "936": [1.5, 85],
  "937": [1.6, 62],
  "938": [0.3, 0.4],
  "939": [1.2, 113],
  "940": [0.4, 3.6],
  "941": [1.4, 38.6],
  "942": [0.5, 16],
  "943": [1.1, 61],
  "944": [0.2, 0.7],
  "945": [0.7, 27.2],
  "946": [0.6, 0.6],
  "947": [1.2, 6],
  "948": [0.9, 33],
  "949": [1.9, 58],
  "950": [1.3, 79],
  "951": [0.3, 3],
  "952": [0.9, 15],
  "953": [0.2, 1],
  "954": [0.3, 3.5],
  "955": [0.2, 1.5],
  "956": [1.9, 90],
  "957": [0.4, 8.9],
  "958": [0.7, 59.1],
  "959": [0.7, 112.8],
  "960": [1.2, 1.8],
  "961": [1.2, 5.4],
  "962": [1.5, 42.9],
  "963": [1.3, 60.2],
  "964": [1.3, 60.2],
  "965": [1, 35],
  "966": [1.8, 120],
  "967": [1.6, 63],
  "968": [2.5, 310],
  "969": [0.7, 8],
  "970": [1.5, 45],
  "971": [0.6, 35],
  "972": [2, 15],
  "973": [1.6, 37],
  "974": [1.2, 45],
  "975": [4.5, 700],
  "976": [2.5, 90],
  "977": [12, 220],
  "978": [0.3, 8],
  "979": [1.2, 56],
  "980": [1.8, 223],
  "981": [3.2, 160],
  "982": [3.6, 39.2],
  "983": [2, 120],
  "984": [2.2, 320],
  "985": [1.2, 8],
  "986": [1.2, 21],
  "987": [1.4, 4],
  "988": [3.2, 92],
  "989": [2.3, 60],
  "990": [0.9, 240],
  "991": [0.6, 11],
  "992": [1.8, 380.7],
  "993": [1.3, 111],
  "994": [1.2, 36],
  "995": [1.6, 303],
  "996": [0.5, 17],
  "997": [0.8, 30],
  "998": [2.1, 210],
  "999": [0.1, 0.1],
  "1000": [1.2, 30],
  "1001": [1.5, 74.2],
  "1002": [1.9, 152.2],
  "1003": [2.7, 669.7],
  "1004": [0.4, 4.9],
  "1005": [2, 380],
  "1006": [1.4, 35],
  "1007": [2.5, 303],
  "1008": [3.5, 240],
  "1009": [3.5, 280],
  "1010": [1.5, 125],
  "1011": [0.4, 4.4],
  "1012": [0.1, 1.1],
  "1013": [0.2, 2.2],
  "1014": [1.8, 92.2],
  "1015": [1, 12.2],
  "1016": [1.4, 30.1],
  "1017": [1.2, 39.8],
  "1018": [2, 60],
  "1019": [1.8, 93],
  "1020": [3.5, 590],
  "1021": [5.2, 480],
  "1022": [1.5, 162.5],
  "1023": [1.6, 156],
  "1024": [0.2, 6.5],
  "1025": [0.3, 0.3],
};
